export default __webpack_public_path__ + "static/media/claimSupportIcon.fb769c5e.svg";